<template>
  <v-content>
    <v-container fluid fill-height :class="{ 'pa-0': isSm }">
      <v-layout>
        <v-flex>
          <OLoadingDialog :value="isLoading" />

          <QueueDetailsDialog ref="detailsDialog" />

          <SlicerSparkline ref="sparkline" />

          <v-card>
            <v-toolbar flat class="card-bar" v-if="!isSm">
              <v-toolbar-title>Queues</v-toolbar-title>
              <v-btn icon @click="reload" class="ml-2">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-spacer />
              <v-text-field
                v-model="txtFilter"
                append-icon="search"
                label="Filtro por nome..."
                single-line
                hide-details
                class="pa-0"
              />
              <v-spacer />
              <v-switch
                v-model="isGrouped"
                label="Agrupar por org"
                hide-details
              />
            </v-toolbar>

            <v-toolbar flat class="card-bar" v-else>
              <v-btn icon @click="reload">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-spacer />
              <v-switch
                v-model="isGrouped"
                label="Agrupar por org"
                hide-details
              />
            </v-toolbar>

            <v-divider />

            <ODataTable
              v-if="isGrouped"
              :spec="groupedSpec"
              :items="groupedRows"
              :clickable="false"
            />

            <ODataTable
              v-else
              :spec="normalSpec"
              :items="orderedRows"
              @rowClicked="selectRow"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import _ from 'lodash'
import { Queue, PipeDiags } from '@/models'
import { matchAnyLike, sumBy, atMost } from 'oderon-commons/src/utils'

export default {
  pageTitle: 'Filas',
  components: {
    QueueDetailsDialog: require('./QueueDetailsDialog').default,
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    SlicerSparkline: require('./SlicerSparkline').default
  },
  data() {
    return {
      isLoading: false,
      isGrouped: false,
      txtFilter: '',
      rows: [],
      groupedRows: [],
      selectedQueue: null,

      normalSpec: [
        { t: 'Fila', d: 'name', w: 250 },
        { t: 'Veículo|', d: 'vehicleCode', w: 200 },
        {
          t: '',
          code: 'isPaused',
          d: row => {
            let paused = _.get(row, 'isPaused')
            let ignored = _.get(row, 'isIgnored')
            let result = []

            if (paused) result.push('<i class="amber v-icon mdi mdi-alpha-p"/>')
            if (ignored) result.push('<i class="red v-icon mdi mdi-alpha-i"/>')

            return {
              html: `<span class="pi">${result.join('')}</span>`
            }
          }
        },
        {
          t: 'Status|',
          d: r => {
            let state = _.get(r, 'worker.state') || 'missing',
              errMessage = _.get(r, 'worker.lastWorkerErrorMessage')

            if (state == 'stopped' || state == 'errored') {
              errMessage = atMost(errMessage || '(no error msg)', 100)
              return `${state}: ${errMessage}`
            } else {
              return state
            }
          }
        },
        {
          t: 'Act.—Wait.|',
          d: r => {
            return `${r.active || 0}—${r.waiting || 0}`
          },
          w: 50
        }
      ],

      groupedSpec: [
        { t: 'Grupo', d: 'group' },
        { t: 'Filas', d: 'queueCount' },
        {
          t: 'Act./Wait.|',
          d: r => {
            return `${r.active}—${r.waiting}`
          }
        }
      ]
    }
  },
  computed: {
    isSm() {
      return this.$vuetify.breakpoint.smAndDown
    },
    orderedRows() {
      return (
        _.chain(this.rows)
          .filter(r => matchAnyLike(this.txtFilter, r.name))
          // .orderBy([this.order.by], [this.order.dir])
          .value()
      )
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      let rows = await Queue.findAll({ includePaused: true })
      rows.forEach(r => (r.group = r.name.split('/')[0]))

      this.groupedRows = _.chain(rows)
        .groupBy('group')
        .map(l => {
          let group = l[0].group,
            active = sumBy(l, 'active'),
            waiting = sumBy(l, 'waiting'),
            queueCount = l.length
          return { group, active, waiting, queueCount }
        })
        .value()

      this.rows = rows

      this.$refs.sparkline.reload()
    },

    async selectRow(row) {
      let dialog = this.$refs.detailsDialog,
        res = await dialog.open(row.name)

      if (res === 'FLUSH') {
        await this.flushQueue(row.name)
      } else if (res != null) {
        await this.restartWorker(res)
      }
    },

    flushQueue(qname) {
      this.$loading(async () => {
        await Queue.flush(qname)
        await this.fetchData()
        this.$snack('Comando enviado')
      })
    },

    restartWorker(body) {
      // orgCode, clientId, extraInfo
      this.$loading(async () => {
        await PipeDiags.restartWorker(body)
        await this.fetchData()
        this.$snack('Comando enviado')
      })
    }
  }
}
</script>

<style>
.pi .v-icon {
  font-size: 18px;
}
</style>
